/// <reference path="../../../teva/navigation/navigation.ts" />

namespace OfficeGuy {
    export class TableShortcuts {
        static Init($TableBody) {
            $TableBody.on("keydown", function (Event) {
                if (!Event.altKey || (Event.key != "ArrowLeft" && Event.key != "ArrowRight" && Event.key != "ArrowUp" && Event.key != "ArrowDown"))
                    return;

                var $Cell = $(Event.target).closest("td");
                var $CellToFocus;
                if (Event.key == "ArrowLeft") {
                    $CellToFocus = $Cell.nextAll("td:visible").find("input:visible, select:visible, a.teva-selectbox-label:first").first().closest("td");
                    if ($CellToFocus.length == 0)
                        $CellToFocus = $Cell.parent().next().find("td input:visible, select:visible, a.teva-selectbox-label:first").first().closest("td");
                }
                else if (Event.key == "ArrowUp")
                    $CellToFocus = $Cell.parent().prev().children("td")[$Cell.index()];
                else if (Event.key == "ArrowRight") {
                    $CellToFocus = $Cell.prevAll("td:visible").find("input:visible, select:visible, a.teva-selectbox-label:first").last().closest("td");
                    if ($CellToFocus.length == 0)
                        $CellToFocus = $Cell.parent().prev().find("td").find("input:visible, select:visible, a.teva-selectbox-label:first").last().closest("td");
                }
                else if (Event.key == "ArrowDown")
                    $CellToFocus = $Cell.parent().next().children("td")[$Cell.index()];

                if ($CellToFocus != null && $CellToFocus.length != 0)
                    Teva.Navigation.FocusOnFirstField($CellToFocus);
                Event.preventDefault();
                return false;
            });
        }
    }
}
